var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{staticClass:"sosv-product-tree"},[_c('osv-product-tree',{attrs:{"product-tree-id":parseInt(_vm.content.id)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }